module.exports = __webpack_public_path__ + "img/home_icon2.c363f644.png";